
function Telefone(e){
  e=e?.replace(/\D/g,""); //Remove tudo o que não é dígito
  e=e?.replace(/^(\d{2})(\d)/g,"($1) $2"); //Coloca parênteses em volta dos dois primeiros dígitos
  e=e?.replace(/(\d)(\d{4})$/,"$1-$2"); //Coloca hífen entre o quarto e o quinto dígitos
  return e;
}

export default Telefone;
